import React, { useState } from 'react';
import { Navigate, useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { IDS } from '@/constants/testIds';

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  if (admin === undefined) return <div className="min-h-screen flex items-center justify-center">…</div>;
  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      toast.success('Добро пожаловать!');
      nav('/admin');
    } else {
      toast.error(r.error);
    }
  };

  const input = 'w-full bg-transparent border-0 border-b border-border/60 py-3 focus:border-saffron transition-colors text-foreground placeholder:text-foreground/40';

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <Helmet>
        <title>Вход в админку | Ali India Tours</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        onSubmit={submit}
        className="w-full max-w-md"
      >
        <Link to="/" className="overline block mb-8 text-foreground/60 hover:text-saffron">← На сайт</Link>
        <h1 className="font-serif-display text-6xl leading-none mb-2">Панель</h1>
        <p className="text-foreground/60 mb-10">Вход для администратора</p>

        <div className="space-y-6">
          <div>
            <label className="text-[10px] uppercase tracking-widest2 text-foreground/50 mb-1 block">Email</label>
            <input data-testid={IDS.adminEmail} className={input} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-widest2 text-foreground/50 mb-1 block">Пароль</label>
            <input data-testid={IDS.adminPassword} className={input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <button
            data-testid={IDS.adminLoginBtn}
            type="submit"
            disabled={busy}
            className="w-full mt-6 py-4 border border-saffron text-saffron uppercase text-xs tracking-widest2 font-bold hover:bg-saffron hover:text-foreground transition-colors disabled:opacity-50"
          >
            {busy ? 'Входим…' : 'Войти'}
          </button>
        </div>
      </motion.form>
    </div>
  );
}
